{
  "network-error": "Network error. Please check your connection and try again.",
  "unknown-error": "An unknown error occurred.",
  "search": "Search",
  "filter": "Filter",
  "name": "Name",
  "role": "Role",
  "remove": "Remove",
  "street": "Street",
  "settlement": "Settlement",
  "references": "References",
  "opened": "Opened",
  "closed": "Closed",
  "all": "All",
  "admin": "Administration",
  "title_agent": "Title Agent",
  "buyer": "Buyer",
  "buyers": "Buyers",
  "seller": "Seller",
  "sellers": "Sellers",
  "lenders": "Lenders",
  "edit": "Edit",
  "orders": "Orders",
  "menu": "Menu",
  "users": "Users",
  "find-order": "Find Order",
  "workspace": "Workspace",
  "charges": "Charges",
  "proceeds": "Proceeds",
  "closing": "Closing",
  "password": "Password",
  "state": "State",
  "workflow": "Workflow",
  "transaction-types": "Transaction Types",
  "transaction-type": "Transaction Type",
  "type": "Type",
  "email-templates": "Email Templates",
  "done": "Done",
  "loading": "Loading...",
  "license-numbers": "License Numbers",
  "open": "Open",
  "welcome-signin": "Welcome to Championship Title",
  "save": "Save",
  "id": "ID",
  "next": "Next",
  "prev": "Prev",
  "city": "City",
  "zip-code": "ZIP Code",
  "country": "Country",
  "continue": "Continue",
  "organization": "Organization",
  "individual": "Individual",
  "cancel": "Cancel",
  "county": "County",
  "information": "Information",
  "spouse": "spouse",
  "address": "Address",
  "addresses": "Addresses",
  "select-one": "Select one ...",
  "delete": "Delete",
  "borough": "Borough",
  "town": "Town",
  "unincorporated-area": "Unincorporated Area",
  "residence-1-4": "Residence (1-4 Families)",
  "residence-5+": "Residence (5+ Families)",
  "commercial": "Commercial",
  "condominium": "Condominium",
  "planned-unit": "Planned Unit Development",
  "land-and-buildings": "Land and Buildings",
  "tax": "Tax",
  "male": "Male",
  "female": "Female",
  "connect": "Connect",
  "pending": "Pending",
  "no-defined-yet": "No defined yet",
  "no-property-address": "No property address yet",
  "searching": "Searching",
  "invalid": "Invalid",
  "add": "Add",
  "to": "To",
  "modal-delete-confirmation-label": "Confirm by typing",
  "modal-delete-cancel": "Cancel",
  "modal-delete-confirmation": "Yes, delete it",
  "apply": "Apply",
  "general": "General",
  "closing-disclosure": "Closing Disclosure",
  "label": "Label",
  "description": "Description",
  "property": "Property",
  "party": "Party",
  "signer": "Signer",
  "routing": "Routing",
  "bank-name": "Bank Name",
  "bank-address": "Bank Address",
  "account": "Account",
  "reference": "Reference",
  "transfer": "Transfer",
  "holdback": "Holdback",
  "yes": "Yes",
  "village": "Village",
  "confirm": "Confirm",
  "no-search-orders": "No results",
  "split": "Split",
  "contacts": "Contacts",
  "close": "Close",
  "gotIt": "Got It",
  "unexpected-error": "An unexpected error occurred",
  "create": "Create",
  "status": "Status",
  "sortBy": "Sort By",
  "amount": "Amount:",
  "min": "Min",
  "max": "Max",
  "clear-all": "Clear all",
  "clear": "Clear",
  "orderBy-amount-low-to-high": "Amount Low to High",
  "orderBy-amount-high-to-low": "Amount High to Low",
  "rows-per-page": "Rows per page:",
  "noChargeSettings": "No charge settings found",
  "copy-text": "Copy",
  "agency": "Agency",
  "date": "Date",
  "templates": "Templates",
  "byLetterAndNumberLabel": "By Letter and Number",
  "byCodeLabel": "By Code",
  "letterLabel": "Letter",
  "numberLabel": "Number",
  "codeLabel": "Code",
  "setting": "Setting",
  "payeeLabel": "Payee",
  "payeesLabel": "Payees",
  "payersLabel": "Payers",
  "addPayeeLabel": "Add Payee",
  "addPayerLabel": "Add Payer",
  "removeLabel": "Remove",
  "roleLabel": "Role",
  "buyerBeforeLabel": "Buyer Before",
  "buyerAtLabel": "Buyer At",
  "sellerBeforeLabel": "Seller Before",
  "sellerAtLabel": "Seller At",
  "byOthersLabel": "By Others",
  "presetAmountLabel": "Preset Amount",
  "percentageLabel": "Percentage",
  "beforeClosingLabel": "Before Closing",
  "atClosingLabel": "At Closing",
  "otherLabel": "Other",
  "orderMapExplorerTitle": "Order Map",
  "propertyFilterTitle": "Property Filter",
  "stateAndEquivalentLabel": "State and Equivalent",
  "countyLabel": "County",
  "coreAreaLabel": "Core area",
  "metropolitanDivisionLabel": "Metropolitan Division",
  "urbanAreaLabel": "Urban Area",
  "searchByZipPlaceholder": "Search by ZIP code",
  "relatedOrdersTitle": "Related Orders",
  "totalLabel": "Total",
  "filterByAddressPlaceholder": "Filter by address or order number",
  "or": "OR",
  "actionsHeader": "Actions",
  "phonesLabel": "Phones",
  "addressesLabel": "Addresses",
  "emailsLabel": "Emails",
  "createContactButton": "Create Contact",
  "createPersonButton": "Create Person",
  "createOrganizationButton": "Create Organization",
  "updateChargeSettingTitle": "Update Charge Setting",
  "createChargeSettingTitle": "Create Charge Setting",
  "percent": "Percent",
  "no": "No",
  "error-try-again": "There was an error, please try again",
  "terms-of-service": "Terms of Service",
  "selected-contact": "Selected Contact:",
  "ok": "Ok",
  "payee-select-contact": "Please select a contact, or you can create a new one in the last option:",
  "payee-found-text": "We found the next text as payee in the document:",
  "payee-current-contact": "Current contact selected as payee:",
  "months-per-year": "Months per year",
  "paid-in-advance": "Paid in Advance",
  "select-county-tdi": "Select County (TDI Code)",
  "number-of-pages": "Number of Pages",
  "number-of-names": "Number of Names",
  "delete-setting": "Delete Setting",
  "delete-setting-confirm": "Are you sure you want to delete the setting?",
  "view-order": "View order",
  "edit-parties": "Edit parties",
  "assistant-placeholder": "Assistant",
  "retry": "Retry",
  "view": "View >",
  "configuration": "Configuration",
  "inference": "Inference",
   "english": "English",
   "spanish": "Spanish",
   "language": "Language",
  "change-to-spanish": "Cambiar a Español",
  "change-to-english": "Change to English",
  "target-spanish": "Español",
  "target-english": "English",
   "ai": "AI",
  "notDefinedYet": "not defined yet",
  "agent-name": "Agent Name",
  "on-progress": "In Progress",
  "receiptInfo": "{{description}}({{amount}}, date: {{date}})",
  "kindsLabel": "kinds: {{kinds}}",
  "source": "Source",
  "createWireTransfer": "Create Wire Transfer",
  "and": "and",
  "from": "from",
  "filePath": "File Path",
  "fileName": "File Name",
  "fileType": "File Type",
  "fileSize": "File Size",
  "creationDate": "Creation Date",
  "lastModifiedDate": "Last Modified Date",
  "lastAccessedDate": "Last Accessed Date",
  "size": "Size",
  "not-set": "Not Set",
  "internal-server-error": "Internal server error",
  "drop-items-here": "Drop items here",
  "aiConfig": {
    "title": "AI Options",
    "newPrompt": "New Prompt",
    "configureAI": "Configure AI Options",
    "cancel": "Cancel",
  "save": "Save",
  "back": "Back",
    "update": "Update",
    "create": "Create",
    "delete": "Delete",
    "confirmDelete": "Are you sure you want to delete this prompt?",
    "promptName": "Prompt Name",
    "promptModel": "Model",
    "actions": "Actions",
    "noPrompts": "No prompts configured yet",
    "editPrompt": "Edit Prompt",
    "createPrompt": "Create Prompt",
    "promptNameLabel": "Prompt Name",
    "promptModelLabel": "Model",
    "descriptionLabel": "Description",
    "contentLabel": "Content",
    "promptSystem": "System Prompt",
    "promptSystemEnglish": "English",
    "promptSystemSpanish": "Spanish",
    "promptScreen": "Screen Prompt",
    "promptScreenEnglish": "English",
    "promptScreenSpanish": "Spanish",
    "promptImage": "Image Prompt",
    "promptImageEnglish": "English",
    "promptImageSpanish": "Spanish",
    "modelAgent": "AI Agent Model"
  }
}
